import PusherSocket from "@/helpers/socket/pusher.socket";
import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { PUSHER_STATES } from "@/resources/constants/pusher";
import moment from "moment";
@Component({})
export default class BackGroundHelper extends mixins(PusherSocket) {
  mounted() {
    let timeOut = null;
    type ValidDurationKeys = 'h';
    document.addEventListener("visibilitychange", async (event) => {
      if (document.hidden) {
        const timer = moment.duration(
          process.env.VUE_APP_BACKGROUND_TIME,
          process.env.VUE_APP_BACKGROUND_KEY as ValidDurationKeys,
        );
        timeOut = setTimeout(async () => {
          await this.$store.dispatch(
            "SystemStore/setShowExitModalAction",
            true
          );
        }, timer.asMilliseconds());
        /* if (process.env.VUE_APP_ENVIRONMENT !== "PRO")
          console.log("onFocusChanged ", false);*/
      } else {
        clearTimeout(timeOut);
        timeOut = null;
        localStorage.setItem("BACK_TIME", null);
        /* if (process.env.VUE_APP_ENVIRONMENT !== "PRO") {
          console.log("onFocusChanged ", true);
          console.log("onFocusChanged STATE PUSHER ", this.getPusherStatus());
        }*/
        if (
          this.getPusherStatus() != null &&
          this.getPusherStatus() == PUSHER_STATES.UNAVAILABLE
        )
          window.location.reload();
      }
    });
  }
}
